var _rect, _path, _path2, _path3, _polyline, _path4, _polyline2, _path5, _polygon, _path6, _polygon2, _polygon3, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _g, _g2, _g3, _g4, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudBackup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 1080 1080",
    viewBox: "0 0 1080 1080",
    id: "cloud-backup",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 1080,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e9faff",
    d: "M701.48,393.82c-123.85-127.22-99.5-232.86-237.56-233.43c-215.7-0.9-353.56,222.01-346.57,477.33 c5.7,208.16,197.64,264.94,373.42,264.94c61.99,0,120.61-13.9,172.68-38.64c34.04-16.17,71.37-24.92,109.32-25.09 c0.74,0,1.48-0.01,2.22-0.02c128.51-1.73,230.92-101.8,230.92-225.59c0-67.97-25.38-136.45-80.59-170.28 C842.48,392.29,738.49,431.84,701.48,393.82z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e8e8e8",
    d: "M791.52,650.7l-5.56-0.52c0.9-9.58,1.42-19.28,1.54-28.84l5.58,0.07C792.96,631.12,792.43,640.97,791.52,650.7 z M792.25,592.09l-5.57,0.38c-0.05-0.74-0.1-1.48-0.16-2.22c-0.67-8.82-1.68-17.73-3.02-26.48l5.52-0.84 c1.35,8.88,2.39,17.93,3.06,26.9C792.15,590.58,792.2,591.34,792.25,592.09z M777.98,535.44c-2.22-9.33-4.86-18.67-7.84-27.78 l5.31-1.74c3.03,9.25,5.7,18.75,7.96,28.22L777.98,535.44z M760.06,480.62c-3.71-8.83-7.84-17.62-12.27-26.13l4.95-2.58 c4.5,8.64,8.69,17.58,12.47,26.55L760.06,480.62z M733.42,429.44c-5.11-8.12-10.61-16.13-16.35-23.8l4.47-3.35 c5.83,7.79,11.42,15.92,16.61,24.17L733.42,429.44z M698.84,383.25c-6.36-7.19-13.08-14.2-19.99-20.84l3.87-4.03 c7.02,6.74,13.85,13.86,20.3,21.17L698.84,383.25z M657.23,343.26c-7.44-6.06-15.21-11.89-23.11-17.32l3.16-4.6 c8.02,5.51,15.92,11.43,23.47,17.59L657.23,343.26z M609.67,310.58c-8.32-4.76-16.94-9.24-25.63-13.3l2.37-5.06 c8.82,4.13,17.58,8.68,26.04,13.52L609.67,310.58z M557.41,286.13c-8.98-3.33-18.22-6.33-27.45-8.92l1.51-5.38 c9.38,2.63,18.77,5.68,27.89,9.06L557.41,286.13z M501.86,270.57c-9.39-1.82-18.99-3.28-28.54-4.34l0.62-5.55 c9.7,1.08,19.45,2.56,28.99,4.41L501.86,270.57z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1e3e8",
    d: "M883.47,962.52h36.64c53.82,0,97.45-43.63,97.45-97.45s-43.63-97.45-97.45-97.45c-13,0-25.41,2.55-36.74,7.17 c-1.17-52.8-44.33-95.25-97.42-95.25c-53.08,0-96.25,42.45-97.42,95.25c-11.34-4.62-23.74-7.17-36.74-7.17 c-53.82,0-97.45,43.63-97.45,97.45s43.63,97.45,97.45,97.45h36.63"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    fill: "#fff",
    points: "794.28 809.4 794.28 877.19 821.22 877.19 778.43 919.97 735.66 877.19 762.59 877.19 762.59 809.45"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d1e3e8",
    d: "M348.33,320.25h25.51c37.47,0,67.85-30.38,67.85-67.85s-30.38-67.85-67.85-67.85 c-9.05,0-17.69,1.78-25.58,4.99c-0.81-36.76-30.86-66.31-67.82-66.31s-67.01,29.56-67.82,66.31c-7.89-3.21-16.53-4.99-25.58-4.99 c-37.47,0-67.85,30.38-67.85,67.85s30.38,67.85,67.85,67.85h25.51"
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    fill: "#fff",
    points: "264.17 290.62 264.17 243.41 245.41 243.41 275.2 213.63 304.98 243.41 286.23 243.41 286.23 290.57"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M679.42,306.08c-2.38-0.6-4.81,0.85-5.41,3.23l-22.53,89.23c-0.6,2.38,0.85,4.81,3.23,5.41l59.11,14.92 c2.38,0.6,4.81-0.85,5.41-3.23l21.64-85.72l-5.67-9.76L679.42,306.08z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccc",
    points: "740.95 329.93 735.17 320.25 733.22 327.98"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M700.38,309.97c-2.35-1.17-5.21-0.2-6.37,2.15l-43.7,88.09c-1.17,2.35-0.2,5.21,2.15,6.37l58.36,28.95 c2.35,1.17,5.21,0.2,6.37-2.15l41.98-84.63l-3.72-11.47L700.38,309.97z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ccc",
    points: "759.26 348.79 755.41 337.37 751.62 345.01"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#d1dbd8",
    points: "718.56 355.26 726.64 338.75 719.62 335.31 711.53 351.82 699.55 361.3 718.42 370.53"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17,
    height: 55.28,
    x: 702.84,
    y: 347.77,
    fill: "#d1dbd8",
    transform: "rotate(-63.917 703.893 375.395)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17,
    height: 55.28,
    x: 699.76,
    y: 354.08,
    fill: "#d1dbd8",
    transform: "rotate(-63.917 700.812 381.699)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17,
    height: 55.28,
    x: 696.68,
    y: 360.36,
    fill: "#d1dbd8",
    transform: "rotate(-63.917 697.73 387.984)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17,
    height: 55.28,
    x: 693.6,
    y: 366.66,
    fill: "#d1dbd8",
    transform: "rotate(-63.917 694.648 394.277)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17,
    height: 55.28,
    x: 690.45,
    y: 372.9,
    fill: "#d1dbd8",
    transform: "rotate(-63.917 691.5 400.525)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 2.17,
    height: 55.28,
    x: 687.37,
    y: 379.2,
    fill: "#d1dbd8",
    transform: "rotate(-63.917 688.417 406.82)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#e2900c",
    d: "M540.68,349.43c-0.13,1.06,0.62,2.02,1.68,2.15l75.65,9.34c1.97,0.24,1.74-1.2,1.91-2.59 c0.17-1.39,5.81-47.03,5.81-47.03s5.45-4.25,6.95-5.42s1.46-2.66,2.55-11.49c1.09-8.82,4.67-37.78,4.91-39.79 c0.25-2.01-1.03-1.86-3.2-2.12c-2.17-0.27-18.11-2.23-18.11-2.23l-64.91-8.01L540.68,349.43z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b3b3b3",
    d: "M541.09,350.26l13.56-109.82c0.03-0.24,0.25-0.41,0.49-0.38l74.14,9.15c0.24,0.03,0.41,0.25,0.38,0.49 L616.1,359.51c-0.03,0.24-0.25,0.41-0.49,0.38l-74.14-9.15C541.23,350.72,541.06,350.49,541.09,350.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M541.15,349.74l13.56-109.88c0.03-0.24,0.25-0.41,0.49-0.38l73.44,9.07c0.24,0.03,0.41,0.25,0.38,0.49 L615.46,358.9c-0.03,0.24-0.25,0.41-0.49,0.38l-73.44-9.07C541.29,350.19,541.12,349.97,541.15,349.74z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M541.22,349.19l13.53-109.63c0.03-0.28,0.29-0.48,0.57-0.45l72.53,8.95c0.28,0.03,0.48,0.29,0.45,0.57 l-13.53,109.63c-0.03,0.28-0.29,0.48-0.57,0.45l-72.53-8.95C541.39,349.73,541.19,349.48,541.22,349.19z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fca712",
    d: "M625.5,240.56l-12.82,103.87c-0.74,6.04-0.78,6.28-6.94,5.52c-15.39-1.9-64.66-3.67-65.08-0.31 c0,0,11.46-92.82,13.35-108.14c1.55-12.57,48.59-10.1,66.08-7.9C623.5,234.03,625.92,237.14,625.5,240.56z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.94,
    height: 1.01,
    x: 610.31,
    y: 278.79,
    fill: "#e6e6e6",
    transform: "rotate(-82.964 633.263 279.285)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.94,
    height: 1.01,
    x: 606.91,
    y: 278.37,
    fill: "#e6e6e6",
    transform: "rotate(-82.964 629.862 278.862)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#6e8799",
    d: "M797.87,525.03l-75.41,12.08c-3.58,0.57-6.96-1.86-7.53-5.45l-8.05-50.28c-0.57-3.58,1.86-6.96,5.45-7.53 l75.41-12.08c3.58-0.57,6.96,1.86,7.53,5.45l8.05,50.28C803.9,521.08,801.45,524.45,797.87,525.03z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 773.88,
    cy: 480.84,
    r: 5.76,
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#f2f2f2",
    points: "724.72 525.72 792.17 514.92 775.73 491.99 767.41 506.28 742.95 479.96"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#63b6ba",
    d: "M481.73,271.29l-37.12,7.83c-5.61,1.19-11.12-2.4-12.31-8.02l-7.83-37.12c-1.19-5.61,2.4-11.12,8.02-12.31 l37.12-7.83c5.61-1.19,11.12,2.4,12.31,8.02l7.83,37.12C490.94,264.6,487.35,270.11,481.73,271.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M441.78,229.87c-1.02,0.21-1.68,1.22-1.46,2.24l0.12,0.55l1.24,5.89l3.62,17.16 c-3.56,0.87-6.06,3.11-5.63,5.12c0.44,2.08,1.96,3.52,5.72,2.73c3.76-0.79,6.46-3.12,6.01-5.21c-0.01-0.03-0.02-0.06-0.03-0.09 h0.01l-3.95-18.72c-0.12-0.54,0.23-1.08,0.78-1.19l17.73-3.74c0.54-0.12,1.08,0.23,1.19,0.78l4.76,22.58 c-3.56,0.87-6.06,3.11-5.63,5.12c0.44,2.08,2.13,3.49,5.89,2.7c3.76-0.79,6.46-3.12,6.01-5.21c-0.01-0.02-0.01-0.03-0.01-0.05 h0.01l-5.99-28.42l-1.24-5.89l-0.12-0.55c-0.22-1.02-1.22-1.68-2.24-1.46L441.78,229.87z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 64.19,
    height: 111.35,
    x: 737.84,
    y: 547.79,
    fill: "#e2900c",
    transform: "rotate(-79.006 769.967 603.493)"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#fca712",
    points: "771.72 594.48 818.54 645.49 709.21 624.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffc05a",
    points: "721.45 561.24 768.48 611.17 830.77 582.47"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#83dfff",
    d: "M355.25 541.13H124.51c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5h230.75c2.49 0 4.5 2.01 4.5 4.5S357.74 541.13 355.25 541.13zM420.59 541.13h-26.4c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5h26.4c2.49 0 4.5 2.01 4.5 4.5S423.07 541.13 420.59 541.13zM355.25 593.74h-26.4c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5h26.4c2.49 0 4.5 2.01 4.5 4.5S357.74 593.74 355.25 593.74zM304.46 593.74H69.43c-2.49 0-4.5-2.01-4.5-4.5s2.01-4.5 4.5-4.5h235.02c2.49 0 4.5 2.01 4.5 4.5S306.94 593.74 304.46 593.74z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudBackup);
export default __webpack_public_path__ + "static/media/cloud-backup.01ecdedc4393e64bf48b1df357f4c21a.svg";
export { ForwardRef as ReactComponent };